<template>
    <div style="height: 100%;" class="d-flex d-flex-column align-items-center justify-content-center">
        <img src="/logo.png" alt="citytime logo" style="width: 115px; height: 30px; margin-bottom: 20px;">
        <h1>{{ lang["404"].title }}</h1>
        <h3>{{ lang["404"].message }}</h3>
        <router-link v-if="!isLogged" to="/login" >{{ lang["404"].go_login }}</router-link>
        <router-link v-else :to="{ name: 'watches' }" >
            {{ lang["404"].go_to_home.replace("#match#", loggedUserIsAdmin ? lang["404"].dashboard : lang["404"].watch_browser) }}
        </router-link>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Role } from '@/constants'
export default {
    data: () => ({
        role: Role
    }),
    computed: mapGetters({
        lang: 'lang',
        isLogged: 'session/isLogged',
        loggedUserIsAdmin: 'session/loggedUserIsAdmin'
    })
}
</script>
